import { useTitle } from 'react-use';

import { Layout } from 'CorePackage/MainModule/components/Layout';

import { KnmSearch } from './KnmSearch';

export const KnmSearchPage = () => {
  useTitle('Поиск проверок');

  return (
    <Layout withFooter>
      <KnmSearch />
    </Layout>
  );
};
